// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'caret-right';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m6 4 4.9 4.764A.332.332 0 0 1 11 9a.326.326 0 0 1-.1.236L6 14'
  />
);

export const viewBox = '0 0 18 18';
